import html2pdf from 'html2pdf.js';
import { generateHTML } from './generateHtml';

export const generatePdfFromHTML = async (data) => {
    const htmlContent = generateHTML(data);

    const options = {
        margin: 10,
        filename: `IRN_${data.IRNNo}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
            scale: 2,
            useCORS: true, // IMPORTANT for logo image
        },
        jsPDF: {
            unit: 'mm',
            format: 'a4',
            orientation: 'portrait',
        },
    };

    html2pdf()
        .set(options)
        .from(htmlContent)
        .toPdf()
        .get('pdf')
        .then((pdf) => {
            const blobUrl = pdf.output('bloburl');
            window.open(blobUrl, '_blank'); // ✅ opens in new tab
        });
};
export default generatePdfFromHTML;